import React from "react"
import styled from "styled-components"
import { replace } from "lodash"
import { Button as AntdButton } from "antd"
import { FormNavigationContext } from "../../../Panes/Form"
import { media } from "../../../../components/mediaStyles"
import { colors } from "../../../../components/Color"
import Question from "../Question"

const Section = styled.div`
  text-align: center;
  font-family: GT America, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const Button = styled(AntdButton)`
  font-size: 20px !important;
  height: 50px !important;
  background: ${colors.teal} !important;
  color: ${colors.tertiary} !important;
  transition: all 0.2s ease-out;
  &:hover {
    border-color: ${colors.teal} !important;
    color: ${colors.tertiary} !important;
    font-weight: 500;
  }

  ${media.tablet`
  margin-left: 15px;
  `}
`

export default class NavigationButton extends React.Component {
  state = {
    percentage: 0,
  }

  fillFormResults(text) {
    return replace(text, /(\${.*?})/g, variable => {
      const variableName = variable.replace(/\$|{|}/g, "")
      return this.context.result[variableName] || "-"
    })
  }

  render() {
    return (
      <Section>
        <Question {...this.props.question} />
        <Button
          onClick={() =>
            // this.context.goToIdentifier(this.props.targetIdentifier)
            this.props.navigateTo(this.props.targetIdentifier)
          }
        >
          {this.props.buttonText}
        </Button>
      </Section>
    )
  }
}

NavigationButton.contextType = FormNavigationContext
